/**
 * API Configuration
 * Centralized API configuration constants
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:8787',
  TIMEOUT: 30000, // 30 seconds
  RETRY: {
    RETRIES: 3,
    RETRY_DELAY: 1000, // 1 second
    RETRY_CONDITION: (error: Error) => {
      // Retry on network errors or 5xx server errors
      return !error.message || error.message.includes('Network') || error.message.includes('5');
    },
  },
} as const;

export const API_ENDPOINTS = {
  GOALS: {
    LIST: '/api/goals',
    CURRENT: '/api/goals/current',
    CURRENT_PROGRESS: '/api/goals/current/progress',
    BY_ID: (id: string) => `/api/goals/${id}`,
    SUMMARY: (id: string) => `/api/goals/${id}/summary`,
    COMPLETE: (id: string) => `/api/goals/${id}/complete`,
    CREATE: '/api/goals',
    UPDATE: (id: string) => `/api/goals/${id}`,
    DELETE: (id: string) => `/api/goals/${id}`,
  },
  HIJRI: {
    TODAY: '/api/hijri/today',
    CALENDAR: '/api/hijri/calendar',
    PREFERENCES: '/api/hijri/preferences',
  },
  FEEDBACK: {
    SUBMIT: '/api/feedback',
    LIST: '/api/feedback',
  },
} as const;
